
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verkauf",
      function () {
        return require("private-next-pages/verkauf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verkauf"])
      });
    }
  